import {
  // breakpoints,
  colors,
  // measurements
} from '../../settings/settings';

// export function assignColors() {

//   var $ = $ || jQuery; // added to see solve jquery issue


//   console.log("assign Colors");


//   // we might need to review the specific classes used here to ensure the whole site is correcntly colors
//   //if so delete comments

//   //REVIew colours and delete all commments

//   if ($("body").hasClass("category-_") || $("body").hasClass("category-8")) {
//     // category three is purple; strategic process
//     // reivew if categoiry 3 and 8 are the same?
//     var activeBrandColor = colors.deploipurple,
//       activeBrandColor_50 = colors.deploipurple_50;

//   } else if ($("body").hasClass("category-4")) { // category four is red; Documentation

//     var activeBrandColor = colors.deploired,
//       activeBrandColor_50 = colors.deploired_50;

//   } else if ($("body").hasClass("category-6")) { // category  is blue; 'project'

//     var activeBrandColor = colors.deploiblue,
//       activeBrandColor_50 = colors.deploiblue_50;

//     // } else if ($("body").hasClass("category-6")) { // category six is yellow; Skills
//   } else if ($("body").hasClass("category-7")) { // category six is yellow; Skills - seem like its category 7 instead of 6 - review if futher problems exidts

//     var activeBrandColor = colors.deploiyellow,
//       activeBrandColor_50 = colors.deploiyellow_50;

//   } else if ($("body").hasClass("category-3")) { // category nine is green; BIM assets

//     var activeBrandColor = colors.deploigreen,
//       activeBrandColor_50 = colors.deploigreen_50;

//   } else if ($("body").hasClass("category-12")) { // category twelve is pink; capital investment

//     var activeBrandColor = colors.deploipink,
//       activeBrandColor_50 = colors.deploipink_50;

//   } else if ($("body").hasClass("category-5")) { // category 5 == news

//     var activeBrandColor = colors.deploiorange,
//       activeBrandColor_50 = colors.deploiorange_50;
//     //ideas additions
//   // } else if ($("body").hasClass("single-ideas")) {
//   //   var activeBrandColor = colors.deploidarkgrey,
//   //     activeBrandColor_50 = colors.deploidarkgrey_50;
//   } else { // everything else ; orange

//     var activeBrandColor = colors.deploiorange,
//       activeBrandColor_50 = colors.deploiorange_50;

//   };

//   console.log("activeBrandColor", activeBrandColor);

//   const doc = document.documentElement
//   doc.style.setProperty('--active-brand-color', activeBrandColor);
//   doc.style.setProperty('--active-brand-color-50', activeBrandColor_50);


//   //  COLOUR VARIABLES

//   /*	var deploiwhite = 'rgba(255, 255, 255, 1)'; // white
//       var deploiorange = ' #f16021'; // orange
//       var deploired = 'rgba(239, 65, 48, 1)'; // red
//       var deploipink = 'rgba(243,134,175,1)'; // pink
//       var deploiyellow = 'rgba(250,205,58,1)'; // yellow
//       var deploigreen = 'rgba(70,167,72,1)'; // green
//       var deploiblue = 'rgba(0,159,218,1)'; // blue
//       var deploipurple = 'rgba(107,72,157,1)'; // purple
//   */
//   //@deploi-darkgrey:rgba(167,169, 172, 1); // darkgrey
//   //@deploi-mediumgrey:rgba(209, 211, 212, 1); // mediumgrey
//   //@deploi-lightgrey:rgba(231, 231, 232, 1); // lightgrey
//   //@deploi-black:rgba(0, 0, 0, 1); // black

//   // END SET COLOUR VARIABLES


// } //export   function init()

export function assignColors() {
  console.log("assign Colors");

  const body = document.body;

  let activeBrandColor, activeBrandColor_50;

  if (body.classList.contains("category-_") || body.classList.contains("category-8")) {
    // category three is purple; strategic process
    activeBrandColor = colors.deploipurple;
    activeBrandColor_50 = colors.deploipurple_50;

  } else if (body.classList.contains("category-4")) { // category four is red; Documentation
    activeBrandColor = colors.deploired;
    activeBrandColor_50 = colors.deploired_50;

  } else if (body.classList.contains("category-6")) { // category is blue; 'project'
    activeBrandColor = colors.deploiblue;
    activeBrandColor_50 = colors.deploiblue_50;

  } else if (body.classList.contains("category-7")) { // category six is yellow; Skills - seem like its category 7 instead of 6
    activeBrandColor = colors.deploiyellow;
    activeBrandColor_50 = colors.deploiyellow_50;

  } else if (body.classList.contains("category-3")) { // category nine is green; BIM assets


    activeBrandColor = colors.deploigreen;
    activeBrandColor_50 = colors.deploigreen_50;

  } else if (body.classList.contains("category-12")) { // category twelve is pink; capital investment
    activeBrandColor = colors.deploipink;
    activeBrandColor_50 = colors.deploipink_50;

  } else if (body.classList.contains("category-5")) { // category 5 == news
    activeBrandColor = colors.deploiorange;
    activeBrandColor_50 = colors.deploiorange_50;

  } else { // everything else ; orange
    activeBrandColor = colors.deploiorange;
    activeBrandColor_50 = colors.deploiorange_50;
  }

  console.log("activeBrandColor", activeBrandColor);

  const doc = document.documentElement;
  doc.style.setProperty('--active-brand-color', activeBrandColor);
  doc.style.setProperty('--active-brand-color-50', activeBrandColor_50);


  console.log("assign Colors end");



} // export function init()
